import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import app from './modules/app.js'
import filters from './modules/filters.js'

const store = new Vuex.Store({
    modules: {
        app,
        filters,
    }
});

export default store